import { userPreferencesFavoriteSearchApi } from "@/main/api";
import { RoutesConstants } from "@/main/routes/routesConstants";
import { z } from "zod";

export const KeyValueSchema = z.object({
	key: z.union([z.string(), z.number()]),
	value: z.string(),
});

export const formSchema = z.object({
	licenseOrClaimNr: z.string().optional(),
	insurer: KeyValueSchema.nullable().optional(),
	bodyshopData: z.array(KeyValueSchema).optional(),
	stateData: z.array(KeyValueSchema).optional(),
	subModel: z.string().optional(),
	guidVehicleManufacturer: z.string().optional(),
	guidVehicleModel: z.string().optional(),
	vehicle: z.string().optional(),
	idCartStatus: KeyValueSchema.nullable().optional(),
});

export type TypePredefinedSearch = z.infer<typeof formSchema>;

export function mapPredefinedSearchToForm(data: any): TypePredefinedSearch {
	return {
		licenseOrClaimNr: data.licenseOrClaimNr ?? "",
		insurer: data.insurer ?? null,
		bodyshopData: Array.isArray(data.bodyshopData) ? data.bodyshopData : [],
		stateData: Array.isArray(data.stateData) ? data.stateData : [],
		idCartStatus: data.idCartStatus ?? null,
		guidVehicleManufacturer: data.guidVehicleManufacturer ?? "",
		guidVehicleModel: data.guidVehicleModel ?? "",
		subModel: data.subModel ?? "",
		vehicle: data.vehicle ?? "",
	};
}

export async function saveUserPredefinedSearch(
	data: TypePredefinedSearch | null,
	description: string,
): Promise<boolean> {
	try {
		await userPreferencesFavoriteSearchApi.saveUserPredefinedSearch({
			routeUrl: RoutesConstants.quotationCartPendingToAnswer,
			jsonData: data ? JSON.stringify(data) : "",
			description,
		});

		return true;
	} catch {
		return false;
	}
}

export async function getDetailsUserPredefinedSearch(
	guidUserPredefinedSearch: string,
): Promise<TypePredefinedSearch | null> {
	try {
		const response =
			await userPreferencesFavoriteSearchApi.getDetailsUserPredefinedSearch<any>(guidUserPredefinedSearch);

		if (response?.data?.result) {
			return mapPredefinedSearchToForm(response.data.result);
		}

		return null;
	} catch {
		return null;
	}
}

export async function deleteUserPredefinedSearch(guidUserPredefinedSearch: string): Promise<boolean> {
	try {
		await userPreferencesFavoriteSearchApi.deleteUserPredefinedSearch(guidUserPredefinedSearch);
		return true;
	} catch {
		return false;
	}
}
